import { getState } from "core-web/state";

export default () => {
    let returnValue = "";
    if (typeof window !== "undefined") {
        returnValue = window.location.search;
    } else {
        returnValue = getState().page.search;
    }
    return returnValue;
};
